




































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import JsonCSV from 'vue-json-csv';
import {
  readQuestionResponseData,
  readSessionData,
} from '@/store/sessionData/getters';
import {
  readHasAdminAccess,
  readToken,
} from '@/store/main/getters';
import { dispatchGetQuestionResponses } from '@/store/sessionData/actions';
import store from '@/store';
import { api } from '@/api';

@Component({
  components: {
    JsonCSV,
  }
})
export default class OpenEndedQuestionResponseTab extends Vue {
  @Prop(String) public questionId!: string;
  @Prop(Boolean) public isPublic!: boolean;
  @Prop(Number) public responseCountIn!: number;

  public responseCount = this.responseCountIn;
  public pageNumber = 1;
  public pageLength = 5;
  public pageStart = 0;
  public search = '';

  @Watch('responseCountIn') onResponseCountChanged() {
    this.responseCount = this.responseCountIn;
  }

  public headers = [
    {
      text: this.mobile ? 'Number:' : 'No.',
      value: 'index',
      sortable: false,
      show: true,
      width: '3%',
    },
    {
      text: this.mobile ? 'Response:' : 'Response',
      sortable: false,
      value: 'open_ended_response',
      show: true,
      width: '97%',
    },
    // { 
    //   text: this.mobile ? 'Reason:' : 'Reason',
    //   sortable: false,
    //   value: 'reason',
    //   show: true,
    // },
    { 
      text: '', 
      value: 'data-table-expand', 
      show: true,
    },
  ];

  public btnDisabled = (() => {
    return false;
  })

  public async changeSearchText(value: string) {
    if (value.length > 0 && value.length < 3) return;

    this.search = value;
    await dispatchGetQuestionResponses(store, {
      questionId: this.questionId,
      pageLength: this.pageLength,
      pageNumber: this.pageNumber,
      search: this.search
    });
  }

  public async paginationChanged(pagination: { page: number; itemsPerPage: number; pageStart: number; pageStop: number; pageCount: number; itemsLength: number; search: string}) {
    this.pageStart = pagination.pageStart;
    this.pageNumber = pagination.page;
    this.pageLength = pagination.itemsPerPage;
    await dispatchGetQuestionResponses(store, {questionId: this.questionId, pageLength: pagination.itemsPerPage, pageNumber: pagination.page, search: this.search});
  }

  public get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
  }

  get sessionData() {
    return readSessionData(this.$store);
  }

  get responses() {
    return readQuestionResponseData(this.$store)(this.questionId)?.participants ?? [];
  }

  public async downloadCSV() {
    const token = readToken(this.$store);
    const response = await api.getQuestionResponses(token, this.questionId, 9999, 1, '', [], true);
    if (response.status === 200) {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', 'responses.csv');
      document.body.appendChild(fileLink);
      fileLink.click();
    }
  }
  
  get mobile () {
    return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm';
  }
}
